<template>
  <div class="auth-page-container">
    <div class="ambient-glow ambient-glow--indigo"></div>
    <div class="ambient-glow ambient-glow--rose"></div>

    <v-row align="center" justify="center" class="fill-height ma-0 auth-content-row">
      <v-col cols="12" sm="10" md="8" lg="5" xl="4">
        <v-card class="glass-card pa-6 pa-sm-8 auth-card" elevation="0">
          <div class="text-center mb-8">
            <div class="auth-brand-badge mb-3">
              <v-icon size="32" color="primary">mdi-filmstrip-box</v-icon>
            </div>
            <h1 class="text-h4 font-weight-bold mb-2">Welcome Back</h1>
            <p class="text-body-2 text-medium-emphasis">
              Sign in to manage your Movies, Books, Audiobooks & Comics
            </p>
          </div>

          <login-form @login-success="onLoginSuccess" />

          <v-divider class="my-6" />

          <div class="d-flex flex-column flex-sm-row justify-space-between align-center ga-3">
            <v-btn
              to="/register"
              variant="text"
              size="small"
              class="btn-modern"
              prepend-icon="mdi-account-plus-outline"
            >
              Create Account
            </v-btn>
            <v-btn
              to="/forgot-password"
              variant="text"
              size="small"
              class="btn-modern text-medium-emphasis"
              prepend-icon="mdi-lock-reset"
            >
              Forgot Password?
            </v-btn>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { useRoute, useRouter } from 'vue-router'
import LoginForm from '@/components/LoginForm.vue'
import { resolvePostLoginRedirect } from '@/config/auth-routes'

export default {
  name: 'Login',
  components: {
    LoginForm,
  },
  setup() {
    const router = useRouter()
    const route = useRoute()

    const onLoginSuccess = () => {
      router.replace(resolvePostLoginRedirect(route.query.redirect))
    }

    return {
      onLoginSuccess,
    }
  },
}
</script>

<style scoped>
.auth-page-container {
  min-height: calc(100vh - 72px);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  padding: 32px 16px;
}

.auth-content-row {
  position: relative;
  z-index: 2;
  width: 100%;
}

.auth-card {
  border-radius: 24px !important;
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25) !important;
}

.auth-brand-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: 20px;
  background: rgba(99, 102, 241, 0.12);
  border: 1px solid rgba(99, 102, 241, 0.25);
  box-shadow: 0 8px 24px rgba(99, 102, 241, 0.2);
}

.ambient-glow {
  position: absolute;
  border-radius: 50%;
  filter: blur(120px);
  pointer-events: none;
  opacity: 0.25;
}

.ambient-glow--indigo {
  width: 450px;
  height: 450px;
  top: 10%;
  left: 15%;
  background: #6366f1;
}

.ambient-glow--rose {
  width: 400px;
  height: 400px;
  bottom: 10%;
  right: 15%;
  background: #f43f5e;
}
</style>